import React, { lazy, Component } from 'react';
export function HeroSection() {
  const handleScrollToForm = () => {
    const formSection = document.getElementById('offer');
    if (formSection) {
      formSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
      setTimeout(() => {
        const firstInput = document.getElementById('nombre');
        if (firstInput) firstInput.focus();
      }, 500);
    }
  };
  return <section className="relative min-h-screen bg-[#1A1A1A] flex items-center justify-center overflow-hidden" style={{
    contentVisibility: 'auto'
  }} data-id="element-98">
      <img src="https://cdn.magicpatterns.com/uploads/tKE5zVyGG5GBoPGzrb5NVi/GERFAJ_hero-mobile.webp" alt="GERFAJ - Construcción y Remodelación" className="absolute inset-0 w-full h-full object-cover" width={1400} height={900} fetchPriority="high" loading="eager" decoding="async" srcSet="https://cdn.magicpatterns.com/uploads/tKE5zVyGG5GBoPGzrb5NVi/GERFAJ_hero-mobile.webp 640w, https://cdn.magicpatterns.com/uploads/tKE5zVyGG5GBoPGzrb5NVi/GERFAJ_hero-mobile.webp 1440w" sizes="(max-width: 768px) 640px, 1440px" data-id="element-99" />

      <div className="relative z-10 max-w-[1280px] mx-auto px-4 py-12 md:py-32 text-center" data-id="element-100">
        <h1 className="text-[32px] md:text-[52px] font-extrabold text-white mb-4 md:mb-6" style={{
        lineHeight: '1.15',
        letterSpacing: '-0.02em',
        textShadow: '0 4px 12px rgba(0, 0, 0, 0.8), 0 2px 4px rgba(0, 0, 0, 0.6)'
      }} data-id="element-101">
          Tu obra terminada a tiempo y con cuentas claras.
        </h1>
        <p className="text-[15px] md:text-[17px] text-white/80 font-normal mb-6 md:mb-8 max-w-3xl mx-auto" style={{
        lineHeight: '1.6',
        textShadow: '0 3px 8px rgba(0, 0, 0, 0.7), 0 1px 3px rgba(0, 0, 0, 0.5)'
      }} data-id="element-102">
          Diseño, ejecución y gestión de obra en el área metropolitana de
          Bucaramanga.
        </p>

        <div className="mb-6 md:mb-8 max-w-3xl mx-auto" data-id="element-103">
          <div className="grid grid-cols-2 gap-2 mb-2" style={{
          minHeight: '160px'
        }} data-id="element-104">
            <div className="border-2 border-[#C9922A] rounded-lg overflow-hidden h-40" data-id="element-105">
              <img src="https://cdn.magicpatterns.com/uploads/vSUNJ1oSheLFfj2kZ61bY1/GERFAJ_-_SONESTA.webp" alt="Proyecto Sonesta" className="w-full h-full object-cover" width={364} height={273} sizes="(max-width: 768px) 364px, 400px" loading="lazy" decoding="async" data-id="element-106" />
            </div>
            <div className="border-2 border-[#C9922A] rounded-lg overflow-hidden h-40" data-id="element-107">
              <img src="https://cdn.magicpatterns.com/uploads/t8ggYzobijuVz83R3rcLNu/gerfaj_auditorio_crudo.webp" alt="Proyecto Auditorio" className="w-full h-full object-cover" width={364} height={273} sizes="(max-width: 768px) 364px, 400px" loading="lazy" decoding="async" data-id="element-108" />
            </div>
          </div>
          <div className="grid grid-cols-3 gap-2" style={{
          minHeight: '160px'
        }} data-id="element-109">
            <div className="border-2 border-[#C9922A] rounded-lg overflow-hidden h-40" data-id="element-110">
              <img src="https://cdn.magicpatterns.com/uploads/7fUPPHTcjeE1374i42N7kY/gerfaj_campo_hermoso_LANDING.webp" alt="Proyecto Campo Hermoso" className="w-full h-full object-cover" width={364} height={273} sizes="(max-width: 768px) 364px, 300px" loading="lazy" decoding="async" data-id="element-111" />
            </div>
            <div className="border-2 border-[#C9922A] rounded-lg overflow-hidden h-40" data-id="element-112">
              <img src="https://cdn.magicpatterns.com/uploads/6hB41ZatDNx3Kjju8ntgew/gerfaj_enfermeria.webp" alt="Proyecto Enfermería" className="w-full h-full object-cover" width={364} height={273} sizes="(max-width: 768px) 364px, 300px" loading="lazy" decoding="async" data-id="element-113" />
            </div>
            <div className="border-2 border-[#C9922A] rounded-lg overflow-hidden h-40" data-id="element-114">
              <img src="https://cdn.magicpatterns.com/uploads/wjNTG6PXkzpfwZSccbwBB1/GERFAJ_RUITOQUE_LANDING.webp" alt="Proyecto Ruitoque" className="w-full h-full object-cover" width={364} height={273} sizes="(max-width: 768px) 364px, 300px" loading="lazy" decoding="async" data-id="element-115" />
            </div>
          </div>
        </div>

        <p className="text-[15px] md:text-[17px] font-normal mb-8 md:mb-12 max-w-2xl mx-auto text-[#F4F4F4]" style={{
        lineHeight: '1.6',
        textShadow: '0 3px 8px rgba(0, 0, 0, 0.7), 0 1px 3px rgba(0, 0, 0, 0.5)'
      }} data-id="element-116">
          Nos encargamos de todo para que tú solo disfrutes el resultado.
        </p>
        <button onClick={handleScrollToForm} className="w-full md:w-auto bg-[#E8621A] text-white px-8 md:px-12 py-4 md:py-5 rounded-full font-bold uppercase text-[13px] md:text-[15px] hover:bg-[#d55515] transition-all shadow-2xl shadow-[#E8621A]/30 hover:scale-105 min-h-[52px]" style={{
        lineHeight: '1',
        letterSpacing: '0.08em'
      }} data-id="element-117">
          AGENDAR ASESORÍA GRATIS
        </button>
      </div>
    </section>;
}